import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { ExpandSearch, InputFields, ListActionButton } from "components/common";
import React, { useState, useRef, useEffect } from "react";
import {
  cardTypesInfo,
  columns,
  columnsHinhThucTT,
  dataFields,
  paymentInfo,
} from "./config";
import Icons from "assets/icons";
import {
  cardTypesService,
  medicalExaminationService,
  employeeService,
} from "api";
import "./ExaminationCard.scss";
import ServiceTable from "./ServiceTable/ServiceTable";
import Notification from "components/common/notification/notification";
import AddDiscounts from "./AddDiscounts/AddDiscounts";
import SelectedCards from "./SelectedCards/SelectedCards";
import PaymentBill from "./PaymentBill/PaymentBill";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setDataConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import { setIdPhieuKham } from "redux/reducer/common";
import { STATUS_CARD } from "assets/constants/card-types";
import { P } from "@antv/g2plot";
import { setReloadListCard } from "redux/reducer/receive";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { formatToCurrencyTypeToFixed, toNumber } from "helper/common";

const ExaminationCard = () => {
  let dispatch = useAppDispatch();
  const action = useAppSelector((e) => e.receive);
  const patientRecord = useAppSelector((state) => state.patientRecord);
  const [loading, setLoading] = useState<any>(false);
  const sTRef = useRef<any>();
  const sCRef = useRef<any>();
  const pBRef = useRef<any>();
  const initialValues = {};
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [params, setParams] = useState<any>([]);
  const [form] = Form.useForm();
  const [dataHinhThucTT, setDataHinhThucTT] = useState<any[]>([]);
  const [detailForm] = Form.useForm();
  const [cardTypes, setCardTypes] = useState<any>(null);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [cTRecord, setCTRecord] = useState<any>([]);
  const aDRef = useRef<any>();
  const [paymentForm] = Form.useForm();
  const [dataPhieu, setDataPhieu] = useState<any>(null);
  const [fieldPay, setFieldPay] = useState(paymentInfo);
  const [tongThanhToan, setTongThanhToan] = useState<any>();
  const onPageChange = async (pg, pgSize) => {
    setPage(pg);
    setLimit(pgSize);
    fetchListCardTypes({
      ...params,
      page: pg,
      limit: pgSize,
    });
  };
  const onPrintBill = async () => {
    if (!dataPhieu) {
      Notification("error", "Chưa có thông tin bệnh nhân!");
      return;
    }
    pBRef.current?.setThongTinBN({
      ...dataPhieu,
    });
    pBRef.current?.setThongTinTT({
      ...paymentForm.getFieldsValue(),
    });
    pBRef.current?.setCards([...cTRecord]);
    pBRef.current?.openModal();
  };
  const handleFormChange = (changedValues, allValues) => {
    setParams({ ...allValues });
  };
  const fetchListCardTypes = async (params) => {
    try {
      setLoading(true);
      let response = await cardTypesService.getListCardTypes(params);
      setCardTypes(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const onFinish = async (values) => {
    fetchListCardTypes({
      ...values,
      page: page,
      limit: limit,
    });
  };

  useEffect(() => {
    getListEmployee();
  }, [dataPhieu]);
  const setThanhTien = () => {
    const tongTien = toNumber(paymentForm.getFieldValue("soTien"));
    const tienGiam = paymentForm.getFieldValue("soTienMienGiam");
    const thanhTien = toNumber(tongTien) - toNumber(tienGiam);
    paymentForm.setFieldValue("thanhTien", thanhTien);
  };
  paymentInfo.find((e) => e?.name == "soTienMienGiam").onChange = (e) => {
    setThanhTien();
  };

  const getListEmployee = async () => {
    try {
      const response =
        (await employeeService.searchEmployee({
          page: 1,
          limit: 1000,
        })) || [];
      fieldPay.find((e) => e.name == "nguoiBan").options = response.items.map(
        (e) => {
          return { value: e.hoTen, label: e.hoTen };
        }
      );
      setFieldPay([...paymentInfo]);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const resetFields = async () => {
    paymentForm.resetFields();
    setTongThanhToan(0);
  };
  // useEffect(() => {}, [idPhieuKham]);
  const onAddCardTypes = async () => {
    if (!currentRecord) {
      Notification("error", "Hãy chọn thẻ trước!");
      return;
    }
    let tmp = cTRecord.find((it) => it.ma === currentRecord.maLoaiThe);
    if (!tmp) {
      setCTRecord([
        ...cTRecord,
        {
          ...currentRecord,
          idThe: currentRecord.id,
          ma: currentRecord.maLoaiThe,
          soLuong: 1,
          loai: 0,
        },
      ]);
    } else {
      Notification("error", "Thẻ đã được thêm!");
      return;
    }
  };
  const onSelectRow = async (selectedRows, selectedRowKeys, info) => {
    setCurrentRecord(selectedRows);
  };
  const onAddDiscounts = async () => {
    aDRef.current?.openModal();
  };
  const editFunc = async (record) => {
    setCurrentRecord(record);
  };
  const delFunc = async (record) => {
    try {
      let response = await cardTypesService.delCardTypes({
        id: record.id,
      });
      Notification("success", "Đã xoá!");
      fetchListCardTypes({
        ...params,
        page: page,
        limit: limit,
      });
    } catch (err) {}
  };

  const onSave = async (values) => {
    if (values.id === null || values.id === undefined) {
      Notification("error", "Hãy chọn loại thẻ cần cập nhật trước!");
      return;
    }
    let dichVus = sTRef.current.getData();
    let data = {
      ...values,
      dichVuTrongThes: dichVus.map((it) => ({
        ...it,
        idLoaiThe: values.id,
      })),
    };
    try {
      let response = await cardTypesService.putCardTypes(data);
      Notification("success", "Cập nhật thành công!");
      fetchListCardTypes({
        ...params,
        page: page,
        limit: limit,
      });
    } catch (err) {}
  };
  const onPaymentFinish = async (values) => {
    if (!patientRecord.selected) {
      Notification("error", "Chưa có thông tin bệnh nhân!");
      return;
    }
    if (values?.thanhTien != tongThanhToan) {
      Notification(
        "warning",
        "Tổng tiền thanh toán chưa khớp với giá trị thẻ khám"
      );
      return;
    }
    try {
      let validate = await sCRef.current?.validateFields();
      if (!validate) {
        Notification("warning", "Hãy nhập số số lượng!");
        return;
      }
      let data = {
        tenTaiKhoan: localStorage.getItem("fullName"),
        idPhieuKham: action.dataPassing?.id,
        idBenhNhan: action.dataPassing?.idBenhNhan,
        nguoiBan: values.nguoiBan,
        lyDoMienGiam: values.lyDoMienGiam,
        soTien: values.soTien,
        soTienMienGiam: values.soTienMienGiam,
        hoanThanhThanhToanBenhNhanDtos: values?.hoanThanhThanhToanBenhNhanDtos,
        chiTiets: cTRecord.map((it) => ({
          ...it,
          id: null,
        })),
      };
      // console.log("🚀 ~ onPaymentFinish ~ data:", data);
      let response = await cardTypesService.postDonBanTheKham(data);
      dispatch(setReloadListCard(true));
      Notification("success", "Đã thanh toán!");
    } catch (err) {
      Notification("error", "Thanh toán không thành công!");
    }
  };
  const handleGenerate = async (data) => {
    setCTRecord([
      ...cTRecord,
      ...data.map((it) => ({
        idThe: it.id,
        ma: it.ma,
        trangThai: it.trangThai,
        loai: 1,
        giaBan: it.giaBan,
      })),
    ]);
  };

  columns.map((it) => {
    if (it.dataIndex === "action") {
      it.render = (v, r, i) => {
        return (
          <ListActionButton
            editFunction={() => editFunc(r)}
            deleteFunction={() => delFunc(r)}
          />
        );
      };
    }
  });
  const callPayment = async (val) => {
    paymentForm.setFieldsValue({
      thanhTien: val,
      soTien: val,
    });
  };
  const fetchPKById = async (id) => {
    try {
      let response = await medicalExaminationService.getPKById({
        id: id,
      });
      setDataPhieu(response.data);
    } catch (err) {}
  };

  useEffect(() => {
    fetchListCardTypes({
      page: 1,
      limit: 10,
    });
  }, []);
  useEffect(() => {}, [dataPhieu]);
  useEffect(() => {
    if (patientRecord.selected) {
      fetchPKById(patientRecord.record.id);
      resetFields();
    }

    setCTRecord([]);
    setCurrentRecord(null);
  }, [patientRecord]);
  useEffect(() => {}, [cardTypes]);
  useEffect(() => {
    sCRef.current?.setData(cTRecord);
  }, [cTRecord]);
  useEffect(() => {
    if (currentRecord) {
      detailForm.resetFields();
      detailForm.setFieldsValue({
        ...currentRecord,
      });
      sTRef.current?.setData(currentRecord.dichVuTrongThes);
    } else {
      detailForm.resetFields();
      sTRef.current?.setData([]);
    }
  }, [currentRecord]);
  const getTongTien = () => {
    let tongTien = 0;
    const listThanhToan = paymentForm.getFieldValue(
      "hoanThanhThanhToanBenhNhanDtos"
    );
    listThanhToan?.forEach((e, index) => {
      console.log(e);
      tongTien += toNumber(e?.soTienGiaoDich);
    });
    return tongTien;
  };
  const setTongTien = () => {
    setTongThanhToan(getTongTien());
  };
  return (
    <div className="examination-card">
      <Row gutter={[8, 0]}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <div className="container">
            <Row justify={"space-between"} style={{ marginBottom: "4px" }}>
              {/* <Button
                type="primary"
                icon={<Icons.add rev={0}/>}
                onClick={onAddDiscounts}
              >
                Thêm mã KM
              </Button> */}
              {/* <AddDiscounts ref={aDRef} onGenerate={handleGenerate} /> */}
              <Button
                type="primary"
                icon={<Icons.add />}
                onClick={onAddCardTypes}
              >
                Thêm thẻ
              </Button>
            </Row>
            <Row>
              <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={cardTypes ? cardTypes.data : []}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: cardTypes?.total,
                  pageSize: cardTypes?.limit,
                  current: cardTypes?.page,
                  onChange: onPageChange,
                }}
                onRow={(record) => ({
                  onDoubleClick: () => editFunc(record),
                })}
                bordered
                rowSelection={{
                  type: "radio",
                  onSelect: onSelectRow,
                }}
              />
            </Row>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={14} xl={14}>
          <div className="container">
            <Form form={detailForm} onFinish={onSave}>
              <Space direction="vertical">
                <Row justify={"start"} style={{ marginBottom: "4px" }}>
                  <Typography.Text strong>
                    Chi tiết loại thẻ khám
                  </Typography.Text>
                </Row>
                <Row>
                  <Row gutter={[8, 8]}>
                    <InputFields data={cardTypesInfo} />
                  </Row>
                </Row>
                <Row>
                  <ServiceTable ref={sTRef} />
                </Row>
              </Space>
            </Form>
          </div>
        </Col>
      </Row>
      <div className="container">
        <Row>
          <Typography.Text strong>Chi tiết thẻ được chọn</Typography.Text>
        </Row>
        <Row>
          <SelectedCards
            ref={sCRef}
            callPayment={callPayment}
            setCTRecord={setCTRecord}
          />
        </Row>
      </div>
      <div className="container">
        <Row>
          <Typography.Text strong>Thông tin thanh toán</Typography.Text>
        </Row>
        <Row>
          <Form
            form={paymentForm}
            onFinish={onPaymentFinish}
            initialValues={{
              hinhThucThanhToan: 0,
              nguoiBanThe: localStorage.getItem("fullName"),
            }}
            onValuesChange={(changedValues, values) => {
              console.log(values);
            }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[8, 8]}>
                <InputFields data={fieldPay} />
              </Row>

              <Row style={{ width: "100%" }} justify={"space-between"}>
                <Typography.Text strong>Hình thức thanh toán</Typography.Text>
                <div>
                  <strong> Tổng tiền: </strong>
                  {formatToCurrencyTypeToFixed(
                    toNumber(tongThanhToan),
                    4,
                    "ja-JP"
                  )}{" "}
                  đ
                </div>
              </Row>

              <TableInputAdd
                // className="table-input-add"
                setData={setDataHinhThucTT}
                isCheckbox={undefined}
                isPagination={false}
                data={dataHinhThucTT}
                column={columnsHinhThucTT}
                name="hoanThanhThanhToanBenhNhanDtos"
                form={paymentForm}
                setTongTien={setTongTien}
                setThanhTien={setThanhTien}
              ></TableInputAdd>
              <Row justify={"end"} style={{ gap: "4px" }}>
                <Button type="primary" htmlType="submit">
                  Thanh toán
                </Button>
                <Button
                  type="primary"
                  icon={<Icons.printer />}
                  onClick={onPrintBill}
                >
                  In phiếu
                </Button>
              </Row>
            </Space>
          </Form>
          <Row>
            <PaymentBill ref={pBRef} />
          </Row>
        </Row>
      </div>
    </div>
  );
};

export default ExaminationCard;
